module.exports = __webpack_public_path__ + "assets/img/heart-bg.d6ac8797.png";